// extracted by mini-css-extract-plugin
module.exports = {"downloadsContainer":"DownloadsPage_downloadsContainer__3vmLv","downloadItem":"DownloadsPage_downloadItem__3umH2"};